/** Pinned messages at the top of the chat: shows one at a time (newest pin first); tap to jump, arrow to see the next. */
import { useEffect, useState } from 'react';
import type { ConversationDTO } from '@tc/contracts';
import { jumpToMessage, messageAction } from '../store.ts';
import { useT, useUiLocale } from '../i18n.ts';
import { displayName, readableBody } from './common.tsx';

export function PinnedBar({ conv }: { conv: ConversationDTO }) {
  const t = useT();
  const ui = useUiLocale();
  const [i, setI] = useState(0);
  const pins = conv.pinned;
  useEffect(() => setI(0), [conv.id, pins.length]);
  if (!pins.length) return null;
  const m = pins[Math.min(i, pins.length - 1)]!;
  return (
    <div className="pinned-bar" role="region" aria-label={t('pinned')}>
      <button type="button" className="pinned-main" onClick={() => void jumpToMessage(conv.id, m.id)}>
        <span className="pinned-label">📌 {pins.length > 1 ? t('pinnedN', { i: Math.min(i, pins.length - 1) + 1, n: pins.length }) : t('pinned')}</span>
        <span className="pinned-text">
          <span className="name">{displayName(m.senderId, ui)}:</span> {readableBody(m)}
        </span>
      </button>
      {pins.length > 1 && (
        <button type="button" className="icon-btn" onClick={() => setI((v) => (v + 1) % pins.length)} aria-label={t('pinnedShowAll')} title={t('pinnedShowAll')}>
          ⌄
        </button>
      )}
      <button type="button" className="icon-btn" onClick={() => void messageAction('POST', `/api/messages/${m.id}/pin`, { on: false }).catch(() => {})} aria-label={t('unpin')} title={t('unpin')}>
        ✕
      </button>
    </div>
  );
}
